export const ACTIVATION_FAILED = '@@mah-maps/ACTIVATION_FAILED';
export const ACTIVATION_SUCCEED = '@@mah-maps/ACTIVATION_SUCCEED';